import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Apple({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M9.00029 21.84C9.48029 21.84 10.1763 21.624 10.6323 21.432C11.2563 21.192 11.8803 21.048 12.4323 21.048C12.9363 21.048 13.5123 21.192 14.1843 21.432C14.8083 21.696 15.3363 21.84 15.7923 21.84C16.4163 21.84 16.9923 21.552 17.5443 21.048C17.8803 20.784 18.3363 20.208 18.8883 19.416C19.2963 18.864 19.6563 18.216 19.9683 17.52L20.3043 16.608C18.7683 15.96 17.6163 14.496 17.6163 12.6C17.5683 10.968 18.3123 9.696 19.8003 8.808C18.9363 7.608 17.7123 6.96 16.0803 6.84C15.4323 6.792 14.6883 6.936 13.8243 7.248C12.8883 7.584 12.3123 7.752 12.1443 7.752C11.9523 7.752 11.4243 7.608 10.6803 7.296C9.86429 7.032 9.26429 6.888 8.78429 6.888C7.92029 6.912 7.12829 7.104 6.38429 7.56C5.61629 7.992 5.04029 8.592 4.58429 9.384C4.00829 10.32 3.69629 11.472 3.69629 12.792C3.69629 13.92 3.91229 15.12 4.36829 16.368C4.75229 17.496 5.25629 18.48 5.85629 19.344C6.45629 20.184 6.91229 20.736 7.29629 21.048C7.84829 21.576 8.42429 21.84 9.00029 21.84ZM12.0243 6.456C12.0243 6.576 12.0243 6.696 12.0483 6.816C14.1363 7.008 16.1523 4.728 16.1523 2.544V2.16C15.6483 2.184 15.0963 2.328 14.5443 2.616C13.0083 3.384 12.0243 4.92 12.0243 6.456Z" fill="currentColor" /></Svg>;
}
export default Apple;